module.exports = __webpack_public_path__ + "img/logo_small.a8a8726e.jpeg";